import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';

import { NotificationCardComponent } from '@rpgc-ai/ui/notification-card/notification-card.component';

import { OverlayComponent } from '@rpgc-ai/blocks/overlay/overlay.component';

import { SessionService } from '@rpgc-ai/services/auth/session.service';
import { ChatsService } from '@rpgc-ai/services/chats/chats.service';
import { NotificationsService } from '@rpgc-ai/services/notifications/notifications.service';

@Component({
  imports: [RouterModule, OverlayComponent, NotificationCardComponent],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  readonly #sessionService = inject(SessionService);
  readonly #notificationsService = inject(NotificationsService);
  readonly #chatsService = inject(ChatsService);

  readonly notifications = this.#notificationsService.notifications;

  constructor() {
    // получаем токен
    this.#sessionService.loadSession.set(true);
    this.#chatsService.loadChats.set(true);
  }

  /**
   * Удаление уведомления
   *
   * @param id ID уведомления
   */
  removeNotification(id: string): void {
    this.#notificationsService.removeNotification(id);
  }
}
